const DEFAULT_HOST = "https://api.neufville.family"

export function apiStrings() {
    return fetch(`${DEFAULT_HOST}/strings`).then(res => res.json());
}

export function apiCreateUser(email, fullname, password) {
    return fetch(`${DEFAULT_HOST}/create-user`, {
        method: 'POST',
        body: JSON.stringify({
            email,
            fullname,
            password,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiConfirmUser(clientId, username, confirmationCode) {
    return fetch(`${DEFAULT_HOST}/confirm-user`, {
        method: 'POST',
        body: JSON.stringify({
            clientId,
            username,
            confirmationCode,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiLogin(email, password) {
    return fetch(`${DEFAULT_HOST}/login`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
            email,
            password,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiLogout() {
    return fetch(`${DEFAULT_HOST}/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export async function apiIsLoggedIn() {
    return fetch(`${DEFAULT_HOST}/is-logged-in`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    }).then(res => {
        if (res.ok) {
            if (res.headers.get('AccessToken')) {
                localStorage.setItem('access_token', res.headers.get('AccessToken'));
            }
            return true;
        }
        return false;
    }).catch(error => {
        console.error('Error checking login status:', error);
        return false;
    });
}

export function apiGetContactList() {
    return fetch(`${DEFAULT_HOST}/contact-list`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export function apiGetReunionList() {
    return fetch(`${DEFAULT_HOST}/reunions`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export function apiGetFamilyTree() {
    return fetch(`${DEFAULT_HOST}/family-tree`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export function apiGetTestPhoto() {
    return fetch(`${DEFAULT_HOST}/test-photo`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    })
}

export function apiGetTestPhotoList() {
    return fetch(`${DEFAULT_HOST}/test-photo-list`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    })
}

export function apiGetPhotoList(folder) {
    const params = new URLSearchParams({
        folder
    });

    return fetch(`${DEFAULT_HOST}/photo-list?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
    })
}

export function apiGetPhoto(photoUri) {
    const params = new URLSearchParams({
        photoUri
    });

    return fetch(`${DEFAULT_HOST}/retrieve-photo?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
    })
}

export function apiGetAllForumPosts() {
    return fetch(`${DEFAULT_HOST}/get-all-posts`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
    });
}

export function apiGetForumPost(postUuid) {
    const params = new URLSearchParams({
        post_uuid: postUuid
    });

    return fetch(`${DEFAULT_HOST}/get-post?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
    });
}

export function apiGetComments(postUuid) {
    const params = new URLSearchParams({
        post_uuid: postUuid,
    });

    return fetch(`${DEFAULT_HOST}/get-post-comments?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
    });
}

export function apiCreateForumPost(title, body, attachments) {
    return fetch(`${DEFAULT_HOST}/create-post`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
        body: JSON.stringify({
            title,
            body,
            attachments,
        }),
    });
}

export function apiCreateComment(postUuid, body) {
    return fetch(`${DEFAULT_HOST}/create-post-comment`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        },
        body: JSON.stringify({
            post_uuid: postUuid,
            body,
        }),
    });
}
